import Select from 'shared/components/Select'

import { vehiclesSelector } from 'booking/selectors'

const VehicleSelect = ({
    vehicles,
    selectedVehicles,
    onVehicleSelected,
    isLoading,
    allowMultiple,
    limit,
    reservatedVehicle,
}) => {
    const onChange = selectedVehicles => {
        onVehicleSelected(
            selectedVehicles instanceof Array || !selectedVehicles ? selectedVehicles : [selectedVehicles]
        )
    }

    const options = !!limit && selectedVehicles.length >= limit ? selectedVehicles : vehicles
    const value = reservatedVehicle
        ? vehicles.find(vehicle => vehicle.id.toString() === reservatedVehicle.id)
        : allowMultiple
        ? selectedVehicles
        : selectedVehicles[0]

    return (
        <Select
            options={options}
            value={value}
            getOptionValue={option => option.id}
            getOptionLabel={option => `${option.make} ${option.model} ${option.tag}`}
            onChange={onChange}
            isLoading={isLoading}
            isMulti={allowMultiple}
            delimiter=","
        />
    )
}

const mapStateToProps = createStructuredSelector({
    vehicles: vehiclesSelector,
})

export default connect(mapStateToProps)(VehicleSelect)
